export const DEVICE_HANDOFF_STORAGE_KEY = 'handoffSession';

export const DEVICE_HANDOFF_PATH = '/deviceHandoff';

export const DELAY_OKTA_REDIRECT_TO_SHOW_HANDBACK_NOTICE_MS = 3000;

export enum DeviceHandoffActionType {
    INITIATE = 'deviceHandoff/INITIATE',
    START_ACTIVATION = 'deviceHandoff/START_ACTIVATION',
    ACCOUNT_CREATED = 'deviceHandoff/ACCOUNT_CREATED',
    ACTIVATION_COMPLETED = 'deviceHandoff/ACTIVATION_COMPLETED',
    RESPONDENT_AUTHENTICATED = 'deviceHandoff/RESPONDENT_AUTHENTICATED',
    POLICY_ACCEPTANCE_REQUIRED = 'deviceHandoff/POLICY_ACCEPTANCE_REQUIRED',
    POLICY_ACCEPTED = 'deviceHandoff/POLICY_ACCEPTED',
    REJECTED = 'deviceHandoff/REJECTED',
    RETRY = 'deviceHandoff/RETRY',
    RESPONDENT_TURN_ENDED = 'deviceHandoff/RESPONDENT_TURN_ENDED',
    SITE_USER_RETURNED = 'deviceHandoff/SITE_USER_RETURNED',
    RESET = 'deviceHandoff/RESET',
    /** Mirrors state pushed from another browser tab verbatim, bypassing the reducer's transition checks. */
    OVERWRITE_FROM_OTHER_TAB = 'deviceHandoff/OVERWRITE_FROM_OTHER_TAB',
    /** Updates the route the respondent should be on (e.g. when chaining to the next activity). */
    SET_RESPONDENT_ACTIVITY_LOCATION = 'deviceHandoff/SET_RESPONDENT_ACTIVITY_LOCATION',
}
